package ui.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp

@Composable
fun TwoFieldText(
    label: String,
    message: Any,
    prefix: (@Composable RowScope.() -> Unit)? = null,
    postfix: (@Composable RowScope.() -> Unit)? = null,
    labelStyle: TextStyle = LocalTextStyle.current,
    messageStyle: TextStyle = LocalTextStyle.current,
    modifier: Modifier = Modifier.fillMaxWidth(),
    messageSuffix: String? = null
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        prefix?.invoke(this)
        Text(
            text = label,
            style = labelStyle,
            modifier = Modifier.align(Alignment.CenterVertically),
        )
        Text(
            text = "${message}${messageSuffix ?: ""}",
            textAlign = TextAlign.End,
            modifier = Modifier.weight(1F)
                .align(Alignment.CenterVertically),
            style = messageStyle
        )
        postfix?.invoke(this)
    }
}

@Composable
fun TwoFieldTextIcon(
    label: String,
    icon: ImageVector,
    labelStyle: TextStyle = LocalTextStyle.current,
    modifier: Modifier = Modifier.fillMaxWidth(),
) {
    Row(modifier) {
        Text(
            text = label,
            style = labelStyle,
            modifier = Modifier.weight(1F)
        )
        Space(4.dp)
        Icon(icon, null)
    }
}
